import React, { FC } from 'react';
import styles from './DesktopTable.module.scss';
import DesktopTableRow from './DesktopTableRow';
import Loader from 'components/Generic/Loader';
import classnames from 'classnames';
import { KidsTableProps } from '../shared/types';
import { useI18n } from 'next-localization';

const DesktopTable: FC<KidsTableProps> = ({
  rows,
  isLoading,
  selectedShareClasses,
  onShareClassChange,
  onTogglePastPerformance,
  onTogglePredictivePerformance,
  className,
}) => {
  const { t } = useI18n();
  return (
    <>
      <table className={classnames('d-flex flex-column', className)} aria-label="Kids hub table">
        <thead>
          <tr className={styles.tableHeaderRow}>
            <th
              scope="col"
              className={`section-header-small ${styles.tableHeader} ${styles.bodyDefault}`}
            >
              {t('fundName')}
            </th>
            <th scope="col" className={`section-header-small ${styles.tableHeader}`}>
              {t('kidShareClass')}
            </th>
            <th scope="col" className={`section-header-small ${styles.tableHeader}`}>
              {t('pastPerformance')}
            </th>
            <th scope="col" className={`section-header-small ${styles.tableHeader}`}>
              {t('scenarioCalculation')}
            </th>
            <th scope="col" className={`section-header-small ${styles.tableHeader}`}>
              {t('kid')}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0
            ? rows.map((row) => (
                <DesktopTableRow
                  key={row.id}
                  row={row}
                  selectedShareClass={selectedShareClasses[row.id] ?? 0}
                  onShareClassChange={onShareClassChange}
                  onTogglePastPerformance={onTogglePastPerformance}
                  onTogglePredictivePerformance={onTogglePredictivePerformance}
                />
              ))
            : null}
        </tbody>
      </table>
      <div>
        <Loader
          size={100}
          className="mx-auto my-5 d-block"
          loading={isLoading && rows.length === 0}
        />
      </div>
    </>
  );
};

export default DesktopTable;
